import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-screenshot-help-modal',
  standalone: true,
  imports: [],
  templateUrl: './screenshot-help-modal.component.html',
  styleUrl: './screenshot-help-modal.component.scss'
})
export class ScreenshotHelpModalComponent {

  constructor(private activeModal: NgbActiveModal) { }

  close() {
    this.activeModal.close();
  }
}
